import "core-js/modules/es.array.concat";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import SvgIcons from '@tencent/vft-ui/src/SvgIcons/SvgIcons.vue';
import { loadScript } from '@tencent/vft-utils';
var _window$setting$$ = window.setting.支付面板.引导文案,
    超下限 = _window$setting$$.超下限,
    超上限 = _window$setting$$.超上限;
var loadScriptPromise = null;
export default {
  components: {
    SvgIcons: SvgIcons
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectSelf: true,
      selectOther: false,
      otherNum: 1
    };
  },
  watch: {
    value: function value(val) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (val) {
                  _this.selectSelf = !_this.hasTicket;
                  _this.selectOther = _this.hasTicket;
                } // 会员时默认5份


                if (_this.vipService.isVip) {
                  _this.otherNum = _this.hasTicket ? 3 : 2;
                } else {
                  _this.otherNum = 1;
                }

                if (val && !window.VftSingleCashier) {
                  loadScriptPromise = loadScript('https://vm.gtimg.cn/tencentvideo/script/film/lib/VftSingleCashier.umd.min.js');
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState(['selectPayInfo'])), {}, {
    noVipPrice: function noVipPrice() {
      return (40 - (this.totalNum >= 3 ? 12 : 18)) * this.totalNum;
    },
    hasTicket: function hasTicket() {
      return this.hasTickets[this.selectPayInfo.pid];
    },
    price: function price() {
      return this.vipService.isVip ? this.totalNum >= 3 ? 12 : 18 : 40;
    },
    totalNum: function totalNum() {
      return (!this.hasTicket && this.selectSelf ? 1 : 0) + (this.selectOther ? this.otherNum : 0);
    },
    totalPrice: function totalPrice() {
      return +Number(this.price * this.totalNum).toFixed(2);
    },
    originPrice: function originPrice() {
      return this.vipService.isVip ? +Number(40 * this.totalNum).toFixed(2) : 0;
    },
    // 直播是否结束
    isLiveEnd: function isLiveEnd() {
      return this.selectPayInfo.结束时间 < this.now;
    },
    // 构造购买参数
    buyParams: function buyParams() {
      var key = this.selectPayInfo.activity_name; // 'rocket_girl' //

      var params = {
        appid: '1005',
        // 必填
        items: "".concat(this.isLiveEnd ? "".concat(key, "_dianbo") : key, ":").concat(this.totalNum),
        // 必填
        remark: '',
        // 必填
        hlwofferid: '457304',
        publicParam: {
          report_servtype: '4'
        }
      };

      if (this.selectSelf) {
        params.remark = 'buyForYourself:1';
      }

      return params;
    }
  }),
  methods: {
    close: function close() {
      this.$emit('input', false);
    },
    checkNum: function checkNum(e) {
      var val = +e.target.value;
      if (!val) this.refreshNum(1);
    },
    changeNum: function changeNum(e) {
      var val = +e.target.value;

      if (val) {
        this.refreshNum(val);
      }
    },
    refreshNum: function refreshNum(num) {
      if (num > 300) {
        this.toast(超上限);
        this.otherNum = 300;
      } else if (num < 1) {
        this.toast(超下限);
        this.otherNum = 1;
      } else {
        this.otherNum = num;
      }

      this.selectOther = true;
    },
    // 切换选中状态
    toggleItem: function toggleItem(type) {
      if (type === 'self') {
        this.selectSelf = !this.selectSelf;
        return;
      }

      this.selectOther = !this.selectOther;
    },
    buy: function buy() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.totalNum < 1)) {
                  _context2.next = 3;
                  break;
                }

                _this2.toast('请先选择购买数量');

                return _context2.abrupt("return");

              case 3:
                self = _this2;
                _context2.next = 6;
                return loadScriptPromise;

              case 6:
                // todo 拉起支付组件
                window.VftSingleCashier.buy(_objectSpread(_objectSpread({}, _this2.buyParams), {}, {
                  onSuccess: function onSuccess(res) {
                    console.log('pay succ, orderid:', res.order_id);
                    self.paySuccCb(res);
                  },
                  onCancel: function onCancel() {
                    console.log('user canceled...');
                  }
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 支付回调函数
    paySuccCb: function paySuccCb(res) {
      this.close();
      this.eventBus.$emit('launchShare', {
        action: 'buy',
        type: !this.selectOther ? 'self' : 'other',
        oid: res.order_id,
        price: this.price,
        giftCount: this.selectSelf ? this.totalNum - 1 : this.totalNum,
        activity_name: this.selectPayInfo.activity_name
      });
      this.eventBus.$emit('refreshTicketInfo', this.selectPayInfo);
    }
  }
};